module.exports = __webpack_public_path__ + "static/img/ent-detail-47.a09bd26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-47.jpg
// module id = KZFw
// module chunks = 52